import { __awaiter } from "tslib";
import { DraftCopyService } from "@/services/models/teleOpi/draftCopy";
const moduleCreateDraftCopy = {
    namespaced: true,
    state: {
        draftCopy: {
            id: null,
            user_id: null,
            state: "creada",
            patient_id: null,
            informed_consent_id: null,
            date_interconsult: "",
            origin_node_id: null,
            destination_node_id: null,
            destination_specialty_id: null,
            diagnostic: null,
            motive_interconsult: null,
            cie10_1: null,
            cie10_2: null,
            cie10_3: null,
            history: null,
            pharmacological_history: null,
            clinical_history: null,
            tto: null,
            exams: null,
            others: null,
            priority: null,
            tele_interconsult_child_id: null,
            allergy: null,
            allergy_description: null,
            anamnesis: null,
        },
    },
    getters: {
        getDraftCopy(state) {
            return state.draftCopy;
        },
    },
    mutations: {
        setDraftCopy(state) {
            state.draftCopy = {
                id: null,
                user_id: null,
                state: "creada",
                patient_id: null,
                informed_consent_id: null,
                date_interconsult: "",
                origin_node_id: null,
                destination_node_id: null,
                destination_specialty_id: null,
                diagnostic: null,
                motive_interconsult: null,
                cie10_1: null,
                cie10_2: null,
                cie10_3: null,
                history: null,
                pharmacological_history: null,
                clinical_history: null,
                tto: null,
                exams: null,
                others: null,
                priority: null,
                tele_interconsult_child_id: null,
                allergy: null,
                allergy_description: null,
                anamnesis: null,
            };
        },
        setid(state, payLoad) {
            state.draftCopy.id = payLoad;
        },
        setuser_id(state, payLoad) {
            state.draftCopy.user_id = payLoad;
        },
        setstate(state, payLoad) {
            state.draftCopy.state = payLoad;
        },
        setpatient_id(state, payLoad) {
            state.draftCopy.patient_id = payLoad;
        },
        setinformed_consent_id(state, payLoad) {
            state.draftCopy.informed_consent_id = payLoad;
        },
        setdate_interconsult(state, payLoad) {
            state.draftCopy.date_interconsult = payLoad;
        },
        setorigin_node_id(state, payLoad) {
            state.draftCopy.origin_node_id = payLoad;
        },
        setdestination_node_id(state, payLoad) {
            state.draftCopy.destination_node_id = payLoad;
        },
        setdestination_specialty_id(state, payLoad) {
            state.draftCopy.destination_specialty_id = payLoad;
        },
        setdiagnostic(state, payLoad) {
            state.draftCopy.diagnostic = payLoad;
        },
        setmotive_interconsult(state, payLoad) {
            state.draftCopy.motive_interconsult = payLoad;
        },
        setcie10_1(state, payLoad) {
            state.draftCopy.cie10_1 = payLoad;
        },
        setcie10_2(state, payLoad) {
            state.draftCopy.cie10_2 = payLoad;
        },
        setcie10_3(state, payLoad) {
            state.draftCopy.cie10_3 = payLoad;
        },
        sethistory(state, payLoad) {
            state.draftCopy.history = payLoad;
        },
        setpharmacological_history(state, payLoad) {
            state.draftCopy.pharmacological_history = payLoad;
        },
        setclinical_history(state, payLoad) {
            state.draftCopy.clinical_history = payLoad;
        },
        settto(state, payLoad) {
            state.draftCopy.tto = payLoad;
        },
        setexams(state, payLoad) {
            state.draftCopy.exams = payLoad;
        },
        setothers(state, payLoad) {
            state.draftCopy.others = payLoad;
        },
        setpriority(state, payLoad) {
            state.draftCopy.priority = payLoad;
        },
        settele_interconsult_child_id(state, payLoad) {
            state.draftCopy.tele_interconsult_child_id = payLoad;
        },
        setallergy(state, payLoad) {
            state.draftCopy.allergy = payLoad;
        },
        setallergy_description(state, payLoad) {
            state.draftCopy.allergy_description = payLoad;
        },
        setanamnesis(state, payLoad) {
            state.draftCopy.anamnesis = payLoad;
        },
    },
    actions: {
        createDraftCopy({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                let dataPost = {
                    teleinterconsult: JSON.stringify(state.draftCopy),
                    user_id: JSON.parse(window.localStorage.getItem("user")).id,
                    patient_id: state.draftCopy.patient_id,
                };
                if (!state.draftCopy.id) {
                    let response = yield DraftCopyService.create(dataPost);
                    state.draftCopy.id = response.id;
                }
                else {
                    yield DraftCopyService.update(state.draftCopy.id, dataPost);
                }
            });
        },
    },
};
export default moduleCreateDraftCopy;
